import { Component } from '@angular/core';
import { Router, Event as RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError} from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppMonitoringService } from './services/logging.service';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  private themes:any = {'default':'summertime', 'dark-theme':'luna', 'SleekAndRelaxed':'berry', 'violet-theme':'mochablue', 'kids1-theme':'birthdayCake', 'kids1-theme kids2-theme':'playground'};

  constructor(private router: Router, private loggingService: AppMonitoringService) {
    const navEndEvents = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    );
    navEndEvents.subscribe((event: NavigationEnd) => {
      if(localStorage.getItem('googleAnalytics') !== null){
        gtag('config', localStorage.getItem('googleAnalytics'), { 'page_path': event.urlAfterRedirects } );
      }
    });
  }
  ngOnInit() {
    if(localStorage.getItem('theme') !== null){
      $('body').removeClass('kids1-theme kids2-theme');
      $('body').removeClass('kids1-theme');
      $('body').removeClass('dark-theme');
      $('body').removeClass('SleekAndRelaxed');
      $('body').removeClass('violet-theme');
      $('body').removeClass('summertime');
      $('body').removeClass('default');
      var theme = localStorage.getItem('theme');
      var name = Object.keys(this.themes).find(key => this.themes[key] === theme);
      if(name){
        $('body').addClass(name);
      }
    }
    String.prototype.includes = function (str) {
      var returnValue = false;

      if (this.indexOf(str) !== -1) {
        returnValue = true;
      }

      return returnValue;
    }
   }   
  
}
